export const APP_NAME = 'smartbar';
export const BASE_URL = 'https://smartbarcorp.com';
export const API_URL = 'https://smartbarcorp.com';
export const IP_ADDR = '';
